import Phaser from "phaser"
import { calculateScaleFactor } from "../config/scaling"
export default class LogoScene extends Phaser.Scene {
	constructor() {
		super({ key: "LogoScene" })
	}

	init() {
		this.gameW = this.cameras.main.width
		this.gameH = this.cameras.main.height
	}

	preload() {
		this.load.image("loadingBar", "assets/images/ui/Loading_Bar.png")
		this.load.image("spaceBG2", "assets/images/backgrounds/space_BG2.png")
		this.load.image("gameLogo", "assets/images/ui/GameLogo.png")
		this.load.image("loadingSnail", "assets/images/ui/loadingSnail.png")
		this.load.image("safeZone", "assets/images/SafeZone.png")
	}

	create() {
		let imageBG = this.add
			.image(this.gameW / 2, this.gameH / 2, "spaceBG2")
			.setScale(3)

		let textButton = this.add
			.text(
				this.cameras.main.centerX + 10000,
				this.cameras.main.centerY,
				"OK",
				{
					fontSize: "5px",
					fill: "#11044E",
					fontFamily: '"Gluten", sans-serif',
					fontWeight: "bold",
				},
			)
			.setOrigin(0.5)

		let textButton02 = this.add
			.text(
				this.cameras.main.centerX + 10000,
				this.cameras.main.centerY,
				"OK",
				{
					fontSize: "5px",
					fill: "#11044E",
					fontFamily: '"Space Grotesk", sans-serif',
					fontWeight: "bold",
				},
			)
			.setOrigin(0.5)

		this.scene.launch("OrientationCheck")
		this.scene.start("LoadingScene")
	}
}
